// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__TBtBG","modal":"Modal_modal__JFfZZ","header":"Modal_header__3YdIS","entered":"Modal_entered__wdk+P","content":"Modal_content__h64Pa"};